/* 北京28 */
export default {
  plays: {
    0: {
      rule_id: 40000,
      area_id: 40000,
      play_name: 'PTTZ',
      play_cname: '猜数字',
      special: false,
      unit_price: 2,
      note_tag: 'count',
    },
    1: {
      rule_id: 40001,
      area_id: 40001,
      play_name: 'DXDS',
      play_cname: '大小单双',
      special: false,
      unit_price: 2,
      note_tag: 'count',
    },
    2: {
      rule_id: 40002,
      area_id: 40002,
      play_name: 'BOSE',
      play_cname: '波色',
      special: true,
      unit_price: 2,
      note_tag: 'count',
    },
    3: {
      rule_id: 40003,
      area_id: 40003,
      play_name: 'BAOZI',
      play_cname: '豹子',
      special: true,
      unit_price: 2,
      note_tag: 'count',
    },
    4: {
      rule_id: 40004,
      area_id: 40004,
      play_name: 'TEMABAO3',
      play_cname: '特码包3',
      special: true,
      unit_price: 2,
      note_tag: 'count',
    },
  },
};
